import {useContext, useRef} from "react"
import axios from "axios"
import GlobalContext from "../contexts/GlobalContext"
import useLoader from "../hooks/useLoader"
import useToast from "../hooks/useToast"

export default function useApi(){

    const [globalContext]=useContext(GlobalContext)
    const {manageLoader}=useLoader()
    const {changeToast}=useToast()

    // Guard to avoid multiple redirects on token rejection
    const tokenGuardRef = useRef({ redirected: false })

    const requestApi=async (endpoint,post)=>{

        let url=globalContext.base_url+"api/"+endpoint

        manageLoader("show")
        if(post.not_loader===true){
            manageLoader("hide")
        }

        let postData={
            ...post,
            session_token:globalContext.session_token
        }
        if(post.upload){
            postData=new FormData()
            for(var key in post){
                postData.append(key,post[key])
            }
            postData.append("session_token",globalContext.session_token)
        }
        
        return new Promise((resolve,reject)=>{
            axios({
                method:"post",
                url:url,
                data:postData,
                headers:post.upload?{"Content-Type":"multipart/form-data"}:null
            }).then((response)=>{
                if(globalContext.dev_mode){
                    console.log(endpoint)
                    console.log(postData)
                    console.log(response.data)
                    console.log("-------------------------")
                }
                // Handle rejected token centrally
                if(response?.data?.status === "rejected_token"){
                    manageLoader("hide")
                    if(!tokenGuardRef.current.redirected){
                        tokenGuardRef.current.redirected = true
                        try{ changeToast("error","Tu sesión expiró. Iniciá sesión nuevamente.") }catch(e){}
                        setTimeout(()=>{ window.location.href = "/entrar" }, 1200)
                    }
                    resolve(response.data)
                    return
                }
                manageLoader("hide")
                resolve(response.data)
            }).catch((error)=>{
                manageLoader("hide")
                // HTTP auth errors
                const status = error?.response?.status
                if(status === 401 || status === 403){
                    if(!tokenGuardRef.current.redirected){
                        tokenGuardRef.current.redirected = true
                        try{ changeToast("error","Tu sesión expiró. Iniciá sesión nuevamente.") }catch(e){}
                        setTimeout(()=>{ window.location.href = "/entrar" }, 1200)
                    }
                }
                reject(error)
            })
        })

    }

    return requestApi

}